const currentUrl = window.location.href;
//console.log(currentUrl);
function getEnvironment(url) {
  if (url.includes("localhost")) {
    return "local";
  } else if (url.includes("testapps")) {
    return "dev";
  } else if (url.includes("apps.trainery.one")) {
    return "prod";
  } else {
    //console.log("coming to else part--Config");
    return "prod";
  }
}
export const env = getEnvironment(currentUrl);
//console.log(env);
export const accessImpersontate = (ImpersonatedUser = false) => {
  return ImpersonatedUser && env === "prod";
};
export const GetCookie = (name) => {
  const cookies = document.cookie.split("; ");
  for (let i = 0; i < cookies.length; i++) {
    const [cookieName, cookieValue] = cookies[i].split("=");
    if (cookieName === name) {
      return cookieValue;
    }
  }
  return null;
};

export const REDIRECT_URL =
  env === "local"
    ? "http://localhost:3001/"
    : env === "dev"
    ? "https://testtrak.trainery.one/"
    : "https://trak.trainery.one/";

export const REDIRECT_LEARNING =
  env === "local"
    ? "http://localhost:3001/trak-learning-login"
    : env === "dev"
    ? "https://testtrak.trainery.one/trak-learning-login"
    : "https://trak.trainery.one/trak-learning-login";

export const REDIRECT_LEARNING_DASHBOARD =
  env === "local"
    ? "http://localhost:3001/trak-learning/ca-admin-login/1"
    : env === "dev"
    ? "https://testtrak.trainery.one/trak-learning/ca-admin-login/1"
    : "https://trak.trainery.one/trak-learning/ca-admin-login/1";

export const REDIRECT_CRED =
  env === "local"
    ? "http://localhost:3001/trak-learning/ca-admin-login/2"
    : env === "dev"
    ? "https://testtrak.trainery.one/trak-learning/ca-admin-login/2"
    : "https://trak.trainery.one/trak-learning/ca-admin-login/2";

export const REDIRECT_EVENT =
  env === "local"
    ? "http://localhost:3001/trak-learning/ca-admin-login/3"
    : env === "dev"
    ? "https://testtrak.trainery.one/trak-learning/ca-admin-login/3"
    : "https://trak.trainery.one/trak-learning/ca-admin-login/3";

export const REDIRECT_LEARNERS =
  env === "local"
    ? "http://localhost:3001/trak-learning/ca-admin-login/4"
    : env === "dev"
    ? "https://testtrak.trainery.one/trak-learning/ca-admin-login/4"
    : "https://trak.trainery.one/trak-learning/ca-admin-login/4";

export const REDIRECT_COACHING =
  env === "local"
    ? "http://localhost:3001/trak-coaching-login"
    : env === "dev"
    ? "https://testtrak.trainery.one/trak-coaching-login"
    : "https://trak.trainery.one/trak-coaching-login";

export const REDIRECT_COACHING_DASHBOARD =
  env === "local"
    ? "http://localhost:3001/trak-coaching/ca-admin-login/1"
    : env === "dev"
    ? "https://testtrak.trainery.one/trak-coaching/ca-admin-login/1"
    : "https://trak.trainery.one/trak-coaching/ca-admin-login/1";

export const REDIRECT_COACHEES_CREDS =
  env === "local"
    ? "http://localhost:3001/trak-coaching/ca-admin-login/2"
    : env === "dev"
    ? "https://testtrak.trainery.one/trak-coaching/ca-admin-login/2"
    : "https://trak.trainery.one/trak-coaching/ca-admin-login/2";
export const REDIRECT_ENGAGEMENTS =
  env === "local"
    ? "http://localhost:3001/trak-coaching/ca-admin-login/3"
    : env === "dev"
    ? "https://testtrak.trainery.one/trak-coaching/ca-admin-login/3"
    : "https://trak.trainery.one/trak-coaching/ca-admin-login/3";

export const REDIRECT_DELEGATE =
  env === "prod"
    ? "https://dhr.trainery.one/"
    : "https://testdelegatehr.trainery.one/";

export const REDIRECT_DELEGATE_KNOWLEDGE =
  env === "prod"
    ? "https://dhr.trainery.one/home/knowledge-center/manage-kc"
    : "https://testdelegatehr.trainery.one/home/knowledge-center/manage-kc";

export const REDIRECT_KNOWLEDGE_CA =
  env === "prod"
    ? "https://dhr.trainery.one/home/knowledge-center"
    : "https://testdelegatehr.trainery.one/home/knowledge-center";

export const REDIRECT_DASHBOARD_DHR_SETTINGS =
  env === "prod"
    ? "https://dhr.trainery.one/home/dashboard-settings/settings"
    : "https://testdelegatehr.trainery.one/home/dashboard-settings/settings";

export const REDIRECT_DASHBOARD_DHR =
  env === "prod"
    ? "https://dhr.trainery.one/home/dashboard"
    : "https://testdelegatehr.trainery.one/home/dashboard";

export const REDIRECT_DOCUSTAR =
  env === "prod"
    ? "https://dhr.trainery.one/home/docustor"
    : "https://testdelegatehr.trainery.one/home/docustor";

export const REDIRECT_TNMIS =
  env === "local"
    ? "http://localhost:3001/"
    : env === "dev"
    ? "https://devmis.trainery.one"
    : "https://mis.trainery.one";

export const REDIRECT_EMPLOYEE =
  env === "prod"
    ? "https://coreapps.trainery.one/"
    : "https://testcoreapp.trainery.one/";

export const REDIRECT_PROFILE =
  env === "prod"
    ? "https://coreapps.trainery.one/home/profile"
    : "https://testcoreapp.trainery.one/home/profile";

export const HELP_CENTER_URL =
  "https://traineryone.zohodesk.com/portal/en/kb/trainery-one";

export const IMAGE_LINK =
  env === "prod"
    ? "https://cdn-coreapps.trainery.one/profile-pic"
    : "https://testcoreapp-cdn.trainery.one/profile-pic";

export const TRAK_CLEAR_DATA =
  env === "local"
    ? "http://localhost:3001/clear-data"
    : env === "dev"
    ? "https://testtrak.trainery.one/clear-data"
    : "https://trak.trainery.one/clear-data";

export const EMPLOYEE_CLEAR_DATA =
  env === "prod"
    ? "https://coreapps.trainery.one/clear-data"
    : "https://testcoreapp.trainery.one/clear-data";

export const DHR_CLEAR_DATA =
  env === "prod"
    ? "https://dhr.trainery.one/clear-data"
    : "https://testdelegatehr.trainery.one/clear-data";

export const LMS_CLEAR_DATA =
  env === "prod"
    ? "https://lms.trainery.one/central-logout/"
    : "https://testlms.trainery.one/central-logout/";

export const RC_CLEAR_DATA =
  env === "prod"
    ? "https://rc.trainery.one/rclogout"
    : "https://testrc.trainery.one/rclogout";

export const REPORTS_CLEAR_DATA =
  env === "prod"
    ? "https://reports.trainery.one/signout"
    : "https://testreports.trainery.one/signout";

export const LMS_REDIRECT_NOTIFICATION =
  env === "prod"
    ? "https://lms.trainery.one/central-login-sso/?url_id=11"
    : "https://testlms.trainery.one/central-login-sso/?url_id=11";

export const LMS_REDIRECT_STRUCTURE =
  env === "prod"
    ? "https://lms.trainery.one/central-login-sso/?url_id=12"
    : "https://testlms.trainery.one/central-login-sso/?url_id=12";

export const MS_CONFIG_REDIRECT =
  env === "local"
    ? "http://localhost:3000/getAToken"
    : env === "dev"
    ? "https://testapps.trainery.one/getAToken"
    : "https://apps.trainery.one/getAToken";

export const EMPLOYEE_EARLY_LOGIN =
  env === "prod"
    ? "https://coreapps.trainery.one/central-emp-login"
    : "https://testcoreapp.trainery.one/central-emp-login";

export const ILT_CLEAR_DATA =
  env === "prod"
    ? "https://ilt.trainery.one"
    : "https://testilt1.trainery.one/clear-data";

export const BASE_URL =
  env === "local"
    ? "https://testapps-api.trainery.one/api"
    : env === "dev"
    ? "https://testapps-api.trainery.one/api"
    : "https://apps-api.trainery.one/api";

export const EVENT_TL_REDIRECTION =
  env === "local"
    ? "http://localhost:3001/track/learning-events/program/details"
    : env === "dev"
    ? "https://testtrak.trainery.one/track/learning-events/program/details"
    : "https://trak.trainery.one/track/learning-events/program/details";

export const COURSE_TL_REDIRECTION =
  env === "local"
    ? "http://localhost:3001/track/courses/details"
    : env === "dev"
    ? "https://testtrak.trainery.one/track/courses/details"
    : "https://trak.trainery.one/track/courses/details";

export const SESSION_TL_REDIRECTION =
  env === "local"
    ? "http://localhost:3001/track/learning-events/administration/session"
    : env === "dev"
    ? "https://testtrak.trainery.one/track/learning-events/administration/session"
    : "https://trak.trainery.one/track/learning-events/administration/session";

export const REDIRECT_DASHBOARD_TRAINERY_LEARN =
  env === "prod"
    ? "https://trak.trainery.one/track/learner-board"
    : "https://testtrak.trainery.one/track/learner-board";

export const NEWLMS_CLEAR_DATA =
  env === "prod"
    ? "https://newlms.trainery.one/clear-data"
    : "https://newlms.trainery.one/clear-data";

export const NEWLMS_API_BASE_URL =
  env === "prod"
    ? "https://learn-api.trainery.one"
    : "https://newlms-api.trainery.one";

export const SCORM_PREVIEW =
  env === "prod"
    ? "https://apps.trainery.one/content/"
    : "https://testapps.trainery.one/content/";

export const MIGRATION_REDIRECT_URL = 
  env === "prod" 
    ? "https://apps.traineryhcm.com" 
    : "https://testapps.traineryhcm.com";
